<template>
    <div v-if="isCookieToast" class="cookie-toast-wrap">
        <div class="wrapper">
            <div class="cookie-toast">
                <span @click="setOnlyTech()" class="close"><img src="/Images/close.svg" width="18" height="18" class="image" :alt="localizer.get('App.Common.MectronicMedicale')" /></span>
                <div class="description">
                    <div class="title"><img src="/images/cookie.svg" class="icon" />{{ localizer.get("App.Common.CookiePolicy") }}</div>
                    <div v-html="localizer.get('CookieToast.Common.Description', '<a href=\'' + routes.Terms_CookiePolicy + '\' class=\'link\'>' + localizer.get('CookieToast.Common.ClickHere') + '</a>')" class="description"></div>
                </div>
                <div class="links">
                    <div class="item action">
                        <span @click="setCookieToast()" class="button" data-border>{{ localizer.get("CookieToast.Common.AgreeAll") }}</span>
                    </div>
                    <div class="item tech">
                        <span @click="setOnlyTech()" class="button" data-border>{{ localizer.get("CookieToast.Common.OnlyTechnicians") }}</span>
                    </div>
                    <div class="item custom">
                        <span @click="setCustomize()" class="button" data-border>{{ localizer.get("CookieToast.Common.Customize") }}</span>
                    </div>
                </div>
                <div :class="['customize', !isCustomize ? 'hden' : '']">
                    <div class="list-item">
                        <div class="item">
                            <div class="info" data-full>
                                <div class="type">{{ localizer.get("CookieToast.Common.Technicians") }}</div>
                                MecMedix.com, Google Analytics, Google reCAPTCHAm, Mapbox
                            </div>
                        </div>
                        <div class="item">
                            <div class="info" data-full>
                                <div class="type">{{ localizer.get("CookieToast.Common.Statistics") }}</div>
                                Vimeo
                            </div>
                            <div class="action">
                                <span v-if="isActivateStatistics" @click="setStatistics()" class="button" data-border>{{ localizer.get("CookieToast.Common.Deactivate") }}</span>
                                <span v-else @click="setStatistics()" class="button" data-border>{{ localizer.get("CookieToast.Common.Activate") }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="info">
                                <div class="type">{{ localizer.get("CookieToast.Common.Profiling") }}</div>
                                YouTube e altri servizi Google
                            </div>
                            <div class="action">
                                <span v-if="isActivateProfiling" @click="setProfiling()" class="button" data-border>{{ localizer.get("CookieToast.Common.Deactivate") }}</span>
                                <span v-else @click="setProfiling()" class="button" data-border>{{ localizer.get("CookieToast.Common.Activate") }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="confirm">
                        <span @click="setCustomCookie()" class="button" data-blue>{{ localizer.get("CookieToast.Common.SavePreferences") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from "vue";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

const localizer = Localizer;

const isCookieToast = ref<boolean>(false);
const isCustomize = ref<boolean>(false);
const isActivateStatistics = ref<boolean>(false);
const isActivateProfiling = ref<boolean>(false);
const cookieToastData = ref<any>({ cookiePolicyUrl: null });
const customizeCookieValues = ref<string[]>(["tech"]);
const routes = (window as any).App.routes;

onBeforeMount(async () => {
    if (!CookieHelper.isCookiePolicy()) {
        cookieToastData.value.cookiePolicyUrl = routes.Support_LegalInformations;
        isCookieToast.value = true;
    }
});

function setCookieToast() {
    CookieHelper.setCookiePolicyAll();
    isCookieToast.value = false;
    window.location.reload();
}

function setOnlyTech() {
    CookieHelper.removeCookiePolicyAll();
    isCookieToast.value = false;
    window.location.reload();
}

function setCustomize() {
    isCustomize.value = !isCustomize.value;
}

function setStatistics() {
    isActivateStatistics.value = !isActivateStatistics.value;

    if (isActivateStatistics.value) {
        customizeCookieValues.value.push("stat");
    } else {
        let index = customizeCookieValues.value.indexOf("stat");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setProfiling() {
    isActivateProfiling.value = !isActivateProfiling.value;
    if (isActivateProfiling.value) {
        customizeCookieValues.value.push("profile");
    } else {
        let index = customizeCookieValues.value.indexOf("profile");
        if (index !== -1) {
            customizeCookieValues.value.splice(index, 1);
        }
    }
}

function setCustomCookie() {
    CookieHelper.setCookie("ckp", customizeCookieValues.value.join("|"), 365);
    isCookieToast.value = false;
    window.location.reload();
}
</script>